var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCustomers = function SvgIconCustomers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1.152 2 4.58v6.84l6 3.428 6-3.428V4.58zM15 4 8 0 1 4v8l7 4 7-4z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m8 5.118-3 1.5v2.764l3 1.5 3-1.5V6.618zM12 6 8 4 4 6v4l4 2 4-2z",
    clipRule: "evenodd"
  })));
};
export { SvgIconCustomers as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjAwMDQ1IDEuMTUxNzRMMiA0LjU4MDM0VjExLjQxOTdMOC4wMDA0NSAxNC44NDgzTDE0LjAwMDUgMTEuNDE5N1Y0LjU4MDMyTDguMDAwNDUgMS4xNTE3NFpNMTUuMDAwNSA0TDguMDAwNDcgMEwxIDRWMTJMOC4wMDA0NyAxNkwxNS4wMDA1IDEyVjRaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjAwMDM1IDUuMTE4MDJMNSA2LjYxODA2VjkuMzgxOTRMOC4wMDAzNSAxMC44ODJMMTEuMDAwNSA5LjM4MTk2VjYuNjE4MDRMOC4wMDAzNSA1LjExODAyWk0xMi4wMDA1IDZMOC4wMDAzNyA0TDQgNlYxMEw4LjAwMDM3IDEyTDEyLjAwMDUgMTBWNloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";